<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
        <div class="container">
            <div class="page-banner-content">
                <h1>Enrichment Initiative</h1>
                <ul>
                    <li><a href="/">Home</a></li>
                    <li>IQAC</li>
                    <li>Enrichment Initiative</li>
                </ul>
            </div>
        </div>
    </div>
    <!--End Page Banner-->

    <!-- Start EI area -->
    <div class="alumni-area pt-100 pb-70">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="alumni-left-content">
              <div class="related-download">
                <ul>
                  <li>
                    <a
                      href="vf/documents/naac/others/enrichment_initiative.pdf"
                      target="_blank"
                      ><i class="flaticon-search"></i>Enrichment Initiative<span
                        style="float: right"
                        ><strong>Click Here</strong></span
                      ></a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End EI area -->

    <!-- Start Bottom Connect Area -->
    <div class="alumni-interview-area pb-100">
        <div class="container">
            <div class="interview-content ptb-100">
                <div class="interview">
                    <a href="/newsletter" class="default-btn btn">Newsletter<i class="flaticon-next"></i></a>
                    <router-link  to="/applynow" class="default-btn btn">Apply Now</router-link>
                </div>
            </div>
        </div>
    </div>
    <!--End Bottom Connect Area -->


</template>

<script>
export default {
    name: "EnrichmentInitiativeView",
};
</script>
